namespace RioERP.Masters {
    export interface SmsTemplatesRow {
        Id?: number;
        Status?: Web.Enums.SMSEvent;
        SmsTemplate?: string;
        Variables?: string;
        VariableCodes?: string;
        IsActive?: boolean;
        ApiKey?: string;
        Sender?: string;
        EntityId?: string;
        TemplateId?: string;
    }

    export namespace SmsTemplatesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SmsTemplate';
        export const localTextPrefix = 'Masters.SmsTemplates';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Status = "Status",
            SmsTemplate = "SmsTemplate",
            Variables = "Variables",
            VariableCodes = "VariableCodes",
            IsActive = "IsActive",
            ApiKey = "ApiKey",
            Sender = "Sender",
            EntityId = "EntityId",
            TemplateId = "TemplateId"
        }
    }
}
